import type { SituacaoUsuario } from '@/types/domain'

export interface OperadorResumo {
  id: string | null
  usuarioId: string
  nome: string | null
  email: string | null
  telefone1: string | null
  telefone1DDI: string | null
  idAnyDesk: string | null
  situacao: SituacaoUsuario
}

export const STATUS_OPERADOR = {
  Todas: 'Todas',
  Ativas: 'Ativas',
  Inativas: 'Inativas',
} as const

export type StatusOperador = (typeof STATUS_OPERADOR)[keyof typeof STATUS_OPERADOR]

export const situacaoOperadorBadges = [
  { value: STATUS_OPERADOR.Ativas, label: 'Ativos', tone: 'success' as const },
  { value: STATUS_OPERADOR.Inativas, label: 'Inativos', tone: 'neutral' as const },
]

export interface ListarOperadoresQuery {
  busca?: string | null
  situacao: StatusOperador
  pageNumber: number
  pageSize: number
}

export interface CriarOperadorPayload {
  nome: string
  email: string
  telefone: string
  telefoneDDI: string
  clienteIntegradoorId?: string | null
}

export interface AtualizarOperadorPayload {
  id: string
  nome: string
  email: string
  telefone: string
  telefoneDDI: string
}
